export const BRANDING = {
  MCP_SERVER_NAME: 'a24z-memory',
  MCP_VERSION: '1.0.0',
} as const;
